import React from "react";

import { useQuery } from "@apollo/client";

import { SERVER_URI } from "../../constants";

import panelInstrumentQuery from "./panel-instrument-query";

interface Props {
  nodes?: any[];
  panelCollectionName: string;
  // panelId?: string;
  // panelName: String;
  panelDefinition: any;
  // startDate: number; // Date;
  // endDate: number; // Date;
  // widgetStatic?: boolean;
  // widgetTitle?: string;
  transform?: any; // function to transform the iconLink
}

function PanelInstrumentContainer(props: Props) {
  const {
    nodes,
    panelCollectionName,
    // panelId,
    panelDefinition,
    // startDate,
    // endDate,
    // widgetStatic,
    // widgetTitle,
    transform,
  } = props;
  const n = nodes ? nodes.join(",") : undefined;
  const { data, error, loading } = useQuery(panelInstrumentQuery, {
    variables: {
      panelName: panelDefinition?.template,
      panelCollectionName: panelCollectionName,
      tab: panelDefinition?.id,
      node: n,
    },
  });
  // console.log("iconLink data", data);
  if (loading) {
    return <div>Loading...</div>;
  }
  if (error) {
    console.error(error.message);
    return <div>Error! {error.message}</div>;
  }

  return (
    <img
      src={`${SERVER_URI}${
        transform ? transform(data.iconLink.iconLink) : data.iconLink.iconLink
      }`}
      style={{ maxWidth: "140px" }}
    />
  );
}

export default PanelInstrumentContainer;
